import { toast } from '@kontentino/ui';
import AppConfig from 'app/config/app';
import { FC, useEffect } from 'react';

const NETWORK_CONNECTION_TOAST_ID = 'NETWORK_CONNECTION_TOAST_ID';

const NetworkStatus: FC = () => {
  const checkForInternetConnection = () => {
    if (!navigator.onLine) {
      toast.warning('Trying to reconnect', {
        id: NETWORK_CONNECTION_TOAST_ID,
        duration: Infinity,
        position: 'bottom-left',
      });
    } else {
      toast.dismiss(NETWORK_CONNECTION_TOAST_ID);
    }
  };

  useEffect(() => {
    const checkForInternetConnectionWithDelay = () => {
      setTimeout(
        checkForInternetConnection,
        AppConfig.TIMEOUT_TO_ALERT_NO_INTERNET,
      );
    };

    window.addEventListener('online', checkForInternetConnection);
    window.addEventListener('offline', checkForInternetConnectionWithDelay);
    return () => {
      window.removeEventListener('online', checkForInternetConnection);
      window.removeEventListener(
        'offline',
        checkForInternetConnectionWithDelay,
      );
    };
  }, []);

  return null;
};

export default NetworkStatus;
